module.exports = __webpack_public_path__ + "static/cad-designs24-af701e08232efabc3ddda90465e0ce9d.png";